import api from '../api';
import { store } from '../store';
import router from '../router';

const state = {
    user: null
};

const actions = {
    user: async ({ commit }, data) => {
        return await api
            .get('/api/v1/user', data, data?.config)
            .then((response) => {
                window.meta.authenticated = true;
                commit('user', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                commit('user', null);
                return Promise.reject(error);
            });
    },
    login: async ({ dispatch }, data) => {
        return await api
            .post('/login', data, data?.config)
            .then(async (response) => {
                await dispatch('user').then(() => {
                    store.dispatch('cart/index');
                });

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    register: async ({ dispatch }, data) => {
        return await api
            .post('/register', data, data?.config)
            .then(async (response) => {
                await dispatch('user').then(() => {
                    store.dispatch('cart/index');
                });

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    checkoutRegister: async ({ dispatch }, data) => {
        return await api
            .post('/checkout/register', data, data?.config)
            .then(async (response) => {
                await dispatch('user');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    logout: ({ commit }) => {
        return api
            .post('/logout')
            .then(async () => {
                window.meta.authenticated = false;
                window.meta.cart = false;

                commit('logout', null);

                sessionStorage.removeItem('auto-applied-coupon');
                sessionStorage.setItem('regionPopupViewed', true);

                await store.commit('cart/clear');
                const url = sessionStorage.getItem('url');
                if (url) {
                    sessionStorage.removeItem('url');
                    location.href = url;
                } else {
                    await router.push('/');
                    location.reload();
                }
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    forgot_password: ({ commit }, data) => {
        return api
            .post('/forgot-password', data, data?.config)
            .then((response) => {
                router.push('/');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    reset_password: ({ commit }, data) => {
        return api
            .post('/reset-password', data, data?.config)
            .then((response) => {
                router.push('/login');
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: ({ commit }, data) => {
        return api
            .put(`/api/v1/users/${data.id}`, data, data?.config)
            .then((response) => {
                commit('user', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update_meta({ commit }, data) {
        return api
            .post('/user/update-currency-language', {
                language: data.language,
                currency: data.currency
            })
            .then((response) => {
                commit('meta', data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    user(state, data) {
        state.user = data;
    },
    meta(state, data) {
        state.user.data.meta.language = data.language;
        state.user.data.meta.currency = data.currency;
    },
    logout(state, data) {
        state.user = data;
    }
};

const getters = {
    get: (state) => {
        return state.user?.data;
    },
    getLanguage: (state) => {
        if (state.user) {
            return state.user.data.meta.language;
        }
    },
    getCurrency: (state) => {
        if (state.user) {
            return state.user.data.meta.currency;
        }
    },
    getName: (state) => {
        if (state.user) {
            return state.user.data.name;
        }
    },
    getEmail: (state) => {
        if (state.user) {
            return state.user.data.email;
        }
    },
    isLoggedIn: (state) => {
        return state.user ? true : false;
    },
    isEmailVerified: (state) => {
        if (state.user) {
            return state.user.data.email_verified;
        }
    },
    isBusinessUser: (state) => () => {
        if (!state.user || !state.user.data.customer?.type) {
            return false;
        }

        return state.user.data?.customer?.type === 'business' ? true : false;
    },
    isPrivateUser: (state) => () => {
        if (!state.user || !state.user.data.customer?.type) {
            return true;
        }

        return state.user.data?.customer?.type === 'private' ? true : false;
    },
    hasCustomer: (state) => {
        return state?.user?.data.customer_id ? true : false;
    },
    receivesNewsletters: (state) => {
        return state?.user?.data.meta.notifications.newsletters ? true : false;
    },
    receivesContentstreams: (state) => {
        return state?.user.data.meta.notifications.contentstreams ? true : false;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
